export default __webpack_public_path__ + "static/play-button-5f20f3b08b4ef8b0466841dd3728e268.mp4";